export default __webpack_public_path__ + "static/media/thomas_m.510ba1a5.png";